import React from 'react';
import DrawerAddBrokerGroup from './body/add';
import DrawerProfile from './body/profile';
import { JSONSchema, TFetchStatus } from 'models';
import { AxiosError } from 'axios';
import { DrawerStyled } from './styles';
import { TBrokerGroup } from '../index';

interface IProps {
  type: string,
  scheme?: JSONSchema,
  dataStatus: TFetchStatus,
  selectedBrokerGroup: TBrokerGroup | null,
  brokerGroupId?: string,
  parentId: string,
  handleDrawerClose: () => void,
  handlePatchBrokerGroup: (brokerGroup: TBrokerGroup, onError: (errors: AxiosError) => void) => void,
  handleDeleteBrokerGroup: () => void,
  updateSelectedBrokerGroup: (brokerGroup: TBrokerGroup) => void,
  handleAddBrokerGroup: (brokerGroup: TBrokerGroup, onError: (error: AxiosError) => void) => void,
}

const Drawer = ({
  type,
  selectedBrokerGroup,
  brokerGroupId,
  parentId,
  handleDrawerClose,
  dataStatus,
  handlePatchBrokerGroup,
  handleDeleteBrokerGroup,
  updateSelectedBrokerGroup,
  handleAddBrokerGroup,
}: IProps) => (
  <DrawerStyled fixed={true} show={!!selectedBrokerGroup || !!brokerGroupId || type === 'add'} dir="right">
    {DrawerBody({
      type,
      selectedBrokerGroup,
      parentId,
      handleDrawerClose,
      dataStatus,
      handlePatchBrokerGroup,
      handleDeleteBrokerGroup,
      updateSelectedBrokerGroup,
      handleAddBrokerGroup
    })}
  </DrawerStyled>
);

const DrawerBody = ({
  type,
  selectedBrokerGroup,
  parentId,
  handleDrawerClose,
  dataStatus,
  handleAddBrokerGroup
}: IProps) => {
  switch (type) {
    case 'add':
      return (
        <DrawerAddBrokerGroup
          handleDrawerClose={handleDrawerClose}
          handlePostBrokerGroup={handleAddBrokerGroup}
          parentId={parentId}
        />
      );
    case 'profile':
    default:
      return (
        <DrawerProfile
          selectedBrokerGroup={selectedBrokerGroup}
          handleDrawerClose={handleDrawerClose}
          dataStatus={dataStatus}
        />
      );
  }
};

export default Drawer;
